var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8414 4.23682C18.8548 4.42276 18.8548 4.60873 18.8548 4.79467C18.8548 10.4659 14.5242 17.0005 6.60916 17.0005C4.17069 17.0005 1.90547 16.2965 0 15.0747C0.34646 15.1145 0.67955 15.1278 1.03934 15.1278C3.05137 15.1278 4.90356 14.4504 6.38263 13.2949C4.49049 13.2551 2.90482 12.0199 2.35849 10.3198C2.62501 10.3596 2.89149 10.3862 3.17134 10.3862C3.55775 10.3862 3.9442 10.3331 4.30395 10.2401C2.33187 9.84166 0.852759 8.11507 0.852759 6.02985V5.97675C1.42571 6.29551 2.09201 6.49473 2.79818 6.52126C1.63891 5.75091 0.879419 4.43605 0.879419 2.94849C0.879419 2.15161 1.09258 1.42112 1.4657 0.783596C3.58437 3.38679 6.76904 5.08681 10.3401 5.27279C10.2735 4.95403 10.2335 4.62202 10.2335 4.28997C10.2335 1.92581 12.1523 0 14.5374 0C15.7766 0 16.8959 0.517982 17.6821 1.35473C18.6548 1.16879 19.5875 0.81017 20.4137 0.318761C20.0939 1.31491 19.4143 2.15165 18.5216 2.68288C19.3877 2.58995 20.2272 2.35083 21 2.01882C20.4138 2.86881 19.6809 3.62583 18.8414 4.23682Z",
    fill: "#FCA905"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0ee3cf2a.svg";
export { ForwardRef as ReactComponent };